var componentsVimeo = $('[data-type="vimeo"] .video-container');

componentsVimeo.each(function () {
    var iframe = $(this).find('iframe');
    var player = new Vimeo.Player(iframe[0]);
    var section = $(this).closest('section');
    player.on('timeupdate', function(data) {
        console.log('timeupdate')
        console.log(data)
        var progressBar = section.find('.video-progress .bar');
        progressBar.css('width', (data.percent * 100) + '%');
        section.find('.image-container').hide()
    });
    attachClickHandler(section, player);
});

function attachClickHandler(section, player) {
    var playBtn = section.find('.video-play');
    var pauseBtn = section.find('.video-pause');
    var muteBtn = section.find('.video-mute');
    var unmuteBtn = section.find('.video-unmute');
    var text = section.find('.video-content');

    if (playBtn.length) {
        playBtn.on('click', function () {
            console.log('play');
            player.play();
            playBtn.attr('data-visible', 'false');
            pauseBtn.attr('data-visible', 'true');
            if ($(window).width() < 1024) {
                text.slideUp();
            }
        });
    }
    if (pauseBtn.length) {
        pauseBtn.on('click', function () {
            console.log('pause');
            player.pause();
            playBtn.attr('data-visible', 'true');
            pauseBtn.attr('data-visible', 'false');
            if ($(window).width() < 1024) {
                text.slideDown();
            }
        });
    }
    if (muteBtn.length) {
        muteBtn.on('click', function () {
            console.log('mute');
            player.setVolume(0);
            muteBtn.attr('data-visible', 'false');
            unmuteBtn.attr('data-visible', 'true');
        });
    }
    if (unmuteBtn.length) {
        unmuteBtn.on('click', function () {
            console.log('unmute');
            player.setVolume(1);
            muteBtn.attr('data-visible', 'true');
            unmuteBtn.attr('data-visible', 'false');
        });
    }
}